import "react";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { useGetVehicleQuery } from "../api/api.js";
import { selectVehicleParameters } from "../model/selectors/selectVehicleParameters.js";
const useGetVehicle = ({ itemId }) => {
  const vehicleParameters = useAppSelector((state) => selectVehicleParameters(state, itemId));
  const queryResult = useGetVehicleQuery(vehicleParameters);
  return queryResult;
};
export {
  useGetVehicle
};
